export default __webpack_public_path__ + "static/media/mode-58.47db84b0.svg";